import React, { useState, useEffect } from 'react';
import { ChevronLeft } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import * as api from '../lib/api';
import PostCard from './PostCard';

const PostPage = ({ postId, onNavigate }) => {
  const { profile } = useAuth();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setNotFound(false);
    api.getPost(postId, profile?.id)
      .then((res) => { if (!cancelled) setPost(res.data); })
      .catch(() => { if (!cancelled) setNotFound(true); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [postId, profile?.id]);

  return (
    <main className="max-w-xl mx-auto px-4 py-6">
      <button
        onClick={() => onNavigate('feed')}
        className="flex items-center gap-1 text-sm text-text-muted hover:text-primary transition-colors mb-4 min-h-[44px]"
        aria-label="Back to feed"
        data-testid="post-page-back-btn"
      >
        <ChevronLeft className="w-5 h-5" aria-hidden="true" /> Back to feed
      </button>

      {loading && (
        <div className="text-center py-12 text-text-muted" data-testid="post-page-loading">Loading...</div>
      )}

      {!loading && (notFound || !post) && (
        <div className="text-center py-12 glass-card rounded-arch-xl" data-testid="post-page-not-found">
          <p className="text-text-muted">This post isn't available.</p>
        </div>
      )}

      {!loading && post && (
        <PostCard post={post} onDelete={() => onNavigate('feed')} onNavigate={onNavigate} />
      )}
    </main>
  );
};

export default PostPage;
